var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfBox"},[(_vm.isClose)?_c('div',{staticClass:"close-btn",on:{"!click":function($event){return _vm.close()}}},[_vm._v(" 关闭预览 ")]):_vm._e(),_c('div',{attrs:{"id":"previewPdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }